/* __next_internal_client_entry_do_not_use__ NotificationBadge auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Row } from "@faire/web--source/slate/Layout";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import React from "react";
import styled, { css } from "styled-components";
import { Notification } from "../icons/foundation/Notification";
import { highVisSlateComponent, HIGH_VIS_FILTER } from "../utils/highVisSlateComponent";
export var NotificationBadge = function(props) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _props_backgroundColor = props.backgroundColor, backgroundColor = _props_backgroundColor === void 0 ? Core.surface.subdued : _props_backgroundColor, content = props.content, _props_contentColor = props.contentColor, contentColor = _props_contentColor === void 0 ? Core.text.default : _props_contentColor, notificationDot = props.notificationDot;
    var notificationDescription = strictLocalize({
        id: "J8xC2I",
        defaultMessage: [
            {
                type: 0,
                value: "with notification"
            }
        ]
    });
    return /*#__PURE__*/ _jsxs(NotificationBadgeWrapper, {
        $backgroundColor: backgroundColor,
        $contentColor: contentColor,
        $isCircular: content < 10,
        "data-test-id": props["data-test-id"],
        className: props.className,
        children: [
            content > 99 ? "99+" : content,
            notificationDot ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(VisuallyHidden, {
                        children: notificationDescription
                    }),
                    /*#__PURE__*/ _jsx(NotificationContainer, {
                        children: /*#__PURE__*/ _jsx(Notification, {})
                    })
                ]
            }) : null
        ]
    });
};
var NotificationBadgeWrapper = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-848e55f7-0"
})([
    "",
    ";background-color:",
    ";block-size:21px;border-radius:100px;color:",
    ";inline-size:fit-content;min-inline-size:22px;white-space:nowrap;position:relative;",
    " ",
    ""
], function(props) {
    return TypographyStyles({
        variant: "paragraphSansMedium",
        theme: props.theme
    });
}, function(props) {
    return props.$backgroundColor;
}, function(props) {
    return props.$contentColor;
}, function(param) {
    var $isCircular = param.$isCircular;
    return $isCircular ? css([
        "width:21px;height:21px;"
    ]) : "padding-inline: 8px";
}, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
var NotificationContainer = styled.div.attrs({
    "aria-hidden": true
}).withConfig({
    componentId: "sc-848e55f7-1"
})([
    "position:absolute;top:0;right:0;"
]);
var VisuallyHidden = styled.div.withConfig({
    componentId: "sc-848e55f7-2"
})([
    "opacity:0;pointer-events:none;position:absolute;"
]);
